import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const productService = {};

productService.getGroupList = () => {
  return fetchV2({
    url: `${env.API_MSP}/products/group`,
    method: "GET",
  });
};

productService.getProductList = params => {
  const columnFilter = params.columnFilter || {};
  return fetchV2({
    url: `${env.API_MSP}/products`,
    method: "GET",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort,
      keywords: params.keywords,
      expand: params.expand,
    },
  });
};
productService.updateStatusProduct = ({ id, record_status }) => {
  return fetchV2({
    url: `${env.API_MSP}/products/${id}`,
    method: "PUT",
    data: {
      record_status,
    },
  });
};
productService.updateProduct = ({ id, data }) => {
  return fetchV2({
    url: `${env.API_MSP}/products/${id}`,
    method: "PUT",
    data,
  });
};
productService.createProduct = data => {
  return fetchV2({
    url: `${env.API_MSP}/products`,
    method: "POST",
    data,
  });
};

export default productService;
